import React from 'react';
import urls, { relativeUrl } from '@/constants/urls';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const CohortLauncherReadOnlyMenu = () => (
  <RibbonMenu
    className="cohort"
    name="cohort"
    icon="filter"
    message="fair.launcher.cohort"
    url={`#${relativeUrl(urls.COHORTS)}`}
  />
);

export default CohortLauncherReadOnlyMenu;
